/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconHouseCross(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.79.036a.62.62 0 0 1 .59.095l6.643 5.164.053.047a.62.62 0 0 1 .186.443v8.118A2.1 2.1 0 0 1 13.165 16H2.834a2.1 2.1 0 0 1-2.096-2.097V5.784c0-.191.089-.372.24-.49L7.618.131l.009-.008v.001L7.696.08l.011-.007zM1.98 6.088v7.815a.857.857 0 0 0 .854.854h10.331a.856.856 0 0 0 .855-.854V6.087l-6.021-4.68zm7.892.839a.622.622 0 0 1 .78.958L8.878 9.659l1.774 1.775a.622.622 0 0 1-.878.879L8 10.536l-1.774 1.777a.62.62 0 0 1-.78.079l-.097-.08a.62.62 0 0 1-.08-.78l.08-.098L7.12 9.659 5.348 7.885a.62.62 0 0 1 0-.879l.097-.08a.62.62 0 0 1 .78.08L7.999 8.78l1.775-1.774z"
      />
    </svg>
  );
}
